<!-- 学生票 坐席不符合学生票购买规定 -->
<template minapp='mpx' xlang='wxml'>
  <contact-dialog
    show="{{show}}"
    title="温馨提醒"
    confirmText="购买成人票"
    cancelText="修改坐席"
    content="学生票仅支持硬座、硬卧、二等座、无座等座席优惠。当前选择了不支持的坐席。请返回修改座席，或购买全价成人票"
    bind:cancel="cancelContactDialog"
    bind:confirm="confirmContactDialog"
  ></contact-dialog>
</template>

<script>
  import { createComponent } from '@didi/es-mpx-creator'
  createComponent({
    componentName: 'StudentConfirmDialog',
    props: {
      show: {
        type: Boolean,
        value: false
      }
    },
    methods: {
      cancelContactDialog() {
        this.$trigger('cancel')
      },
      confirmContactDialog() {
        this.$trigger('confirm')
      }
    }
  })
</script>

<style lang='stylus' scoped>
  .inner-box
    background #F6F7F8
    padding 8px
    font-size 12px 
    line-height 16px
    color #666
    margin 24px 0
    .inner-text
      margin-top 4px
      &:first-child
        margin-top 0
</style>

<script name='json'>
  module.exports = {
    component: true,
    "usingComponents": {
      'contact-dialog': './index'
    }
  }
</script>

